import { HTTP } from '../../utils'

export const getSharedWithUsers = (entityType, entityUuid) => {
  let url = ''
  if (entityType && entityUuid) {
    url = '/' + entityType + '/getSharedWithUserList/' + entityUuid
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      console.log('getSharedWithUsers api response', response)
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const shareUnshareUsers = (sharedUsers, entityType, entityUuid) => {
  console.log('in shareUnshareUsers params: ', sharedUsers, entityType, entityUuid)
  let url = ''
  if (sharedUsers && entityType && entityUuid) {
    url = '/' + entityType + '/shareUnshareWithUser/' + entityUuid
  } else {
    return
  }
  return HTTP().put(url, sharedUsers)
    .then(response => {
      console.log('getSharedWithUsers api response', response)
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const getEntity = (entityType, entityUuid) => {
  let url = ''
  if (entityType && entityUuid) {
    url = '/' + entityType + '/' + entityUuid
  } else {
    return
  }
  console.log('in getEntity api call, url: ', url)
  return HTTP().get(url)
    .then(response => {
      console.log('getEntity api response', response)
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}



// WEBPACK FOOTER //
// ./src/app/sharing/api.js